import User from '../../../types/user';

export const formatDisplayName = <T extends Pick<User, 'username'>>({ username }: T): string => (username ? `@${username}` : '');
